import * as _ from 'lodash';
import { useEffect, useState } from 'react';
import { ICenterRecipient } from '@nkr/models/index';
import { recipientSelectCustomStyles, RecipientSelectWrapper } from './styles';
import Select from 'react-select';

interface IProps {
    centerId: number,
    donorId: number,
    recipientId: number,
    recipientList: ICenterRecipient[],
    onClick: (centerId: number, donorId: number, recipientId: number) => void
}

interface IState {
    label: string,
    value: number
}

const LinkedRecipientSelect = (props: IProps) => {
    const [pairedRecipient, setPairedRecipient] = useState<IState>({ label: '- Select a recipient to pair -', value: 0 });

    useEffect(() => {
        let list = props.recipientList.filter(x => x.id == props.recipientId).map((recipient) => {
            if (recipient.id > 0) {
                return { label: recipient.alias + ' (' + recipient.centerAlias + ')', value: recipient.id };
            } else {
                return { label: recipient.alias, value: recipient.id };
            }
        });

        if (list.length > 0) {
            setPairedRecipient(list[0]);
        }

    }, [props.recipientId, props.recipientList])

    const handleRecipientChange = (e: any) => {
        let selectedRecipientId = e.value;
        let centerId = props.centerId;
        let donorId = props.donorId;

        props.onClick(centerId, donorId, selectedRecipientId);
    };

    const list = props.recipientList.map(recipient => {
        if (recipient.id > 0) {
            return { label: recipient.alias + ' (' + recipient.centerAlias + ')', value: recipient.id };
        } else {
            return { label: recipient.alias, value: recipient.id };
        }
    });

    return (
        <RecipientSelectWrapper isCenter={props.recipientId > 0}>
            <Select
                styles={recipientSelectCustomStyles(props.recipientId > 0)}
                value={pairedRecipient}
                options={list}
                placeholder='Select a recipient to pair'
                onChange={handleRecipientChange}
                onFocus={null}
                isDisabled={false}
            />
        </RecipientSelectWrapper>
    );
}

export default LinkedRecipientSelect;